function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.666 19.998C.666 9.308 9.336.636 20.028.636c10.716 0 19.36 8.672 19.36 19.362 0 10.717-8.644 19.362-19.36 19.362C9.338 39.36.666 30.715.666 19.998z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.533 20.048C.533 9.274 9.273.536 20.045.536c10.8 0 19.512 8.738 19.512 19.512 0 10.8-8.713 19.512-19.512 19.512C9.272 39.56.533 30.847.533 20.048",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.644 14.933c1.255-.063 2.305.125 3.25.75l.227.23V21.1c-.575.667-1.398.98-2.406 1.125-1.13.125-2.304-.125-3.27-.75l-.577-.542v-4.708c1.03-1 1.77-1.25 2.777-1.292z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M5.667 21.61v6.656h4.606V21.61zM13.866 18h2.556l-.11 2.103c.082.902.368 1.948.72 2.753L18 24v4.385h-4.134zM22 9h4v1.458l-.455-.18c-.67-.143-1.366-.178-2.036-.11l-1.51.373zM21.975 26.005l.887.53c.722.214 1.406.203 2.138.097l1.29-.468v2.22h-4.315zM29.896 12.867h4.22v15.385h-4.22v-3.678l.904-1.154c1.432-2.356 1.49-5.48.415-7.91l-1.32-2.042v-.6z"
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.888 14.867L9.956 9.515c-.888-.68-1.042-1.956-.355-2.823.7-.878 1.98-1.042 2.868-.35l6.93 5.35-1.586 1.336z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.647 14.548c1.38-.068 2.53.137 3.57.82l.25.25v5.667c-.634.728-1.537 1.07-2.645 1.23-1.242.135-2.53-.138-3.592-.82l-.633-.592V15.96c1.13-1.093 1.943-1.366 3.05-1.412z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeMiterlimit: 8.28571415
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M5.48 21.577h4.89v6.94H5.48zM13.556 17.536h3.03L16.453 19c.098.953.13 1.148.546 2l1.454 3.196v4.322h-4.898z",
  strokeWidth: 0.80000001,
  strokeMiterlimit: 8.28571415
}), React.createElement("path", {
  d: "M21.566 8.598h4.898v2.46l-.83-.3c-.634-.092-1.212-.138-2.043-.022l-2.024.46z",
  strokeWidth: 0.80000013,
  strokeMiterlimit: 8.28571415
}), React.createElement("path", {
  d: "M21.632 26l1.006.266c.83.26 1.596.26 2.427.13L26.53 26v2.518h-4.898zM29.575 12.552h4.898v15.966h-4.898V24L31 22c1-2 1.352-4.184.106-6.704C30.486 14 30 13 29.576 12.552z",
  strokeWidth: 0.80000001,
  strokeMiterlimit: 8.28571415
}), React.createElement("path", {
  d: "M17 15.27L9.788 9.636c-.924-.715-1.084-2.058-.37-2.97.728-.925 2.06-1.098 2.984-.37l7.21 5.633-1.377 1.6z",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8.28571415
}), React.createElement("path", {
  d: "M30.33 23.182c-2.615 3.365-7.455 3.935-10.794 1.32-3.34-2.614-3.935-7.43-1.32-10.794 2.614-3.34 7.455-3.934 10.794-1.32 3.34 2.614 3.934 7.455 1.32 10.794",
  strokeWidth: 1.39999998,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var SvgInsightSubmenuSummary = function SvgInsightSubmenuSummary(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsightSubmenuSummary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Insight-submenu-summary.15bb51c2.svg";
export { ForwardRef as ReactComponent };